import { useSyncExternalStore } from "react";

/** A tiny hash router: the screen is `#<screenId>`, the way the prototype links. */
function subscribe(onChange: () => void): () => void {
  window.addEventListener("hashchange", onChange);
  return () => window.removeEventListener("hashchange", onChange);
}

export function useHash(): string {
  return useSyncExternalStore(subscribe, () => window.location.hash);
}
